import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LargeHero from './js/large-hero.component';

ComponentsFactory.getInstance().define('large-hero', LargeHero);
